var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20778 3.14887C2.42648 2.92 2.76534 2.85309 3.05462 2.98166L19.5546 10.315C19.8255 10.4354 20 10.704 20 11.0004C20 11.2967 19.8255 11.5653 19.5546 11.6857L3.05462 19.019C2.76534 19.1476 2.42648 19.0807 2.20778 18.8518C1.98908 18.623 1.93762 18.2814 2.0792 17.9983L5.20317 11.7503H11C11.4142 11.7503 11.75 11.4145 11.75 11.0003C11.75 10.5861 11.4142 10.2503 11 10.2503H5.20315L2.0792 4.00243C1.93762 3.71928 1.98908 3.37774 2.20778 3.14887Z"
  })));
};
export default SvgSend;